import { Pipe, PipeTransform } from '@angular/core';

/**
 * Builds the in-app viewer route for a FileV2 document.
 * The viewer requests a fresh signed content URL when it opens, so this link never expires,
 * survives reloads and can be copied or bookmarked by a logged-in user.
 * Returns an empty string when there is no file ID; callers guard the anchor with *ngIf.
 */
export function fileViewerUrl(fileId: number | string | null | undefined): string {
  return fileId ? `/#/file/${fileId}` : '';
}

/**
 * True when the given router URL (or the current hash route when omitted) is the file viewer.
 * The viewer only needs the one FileV2 request, so the application shell skips the SignalR connection
 * and the store preload for it; the full application still loads when the user navigates anywhere else.
 */
export function isFileViewerRoute(url?: string): boolean {
  const route = url ?? window.location.hash.replace(/^#/, '');
  return route.startsWith('/file/');
}

@Pipe({ name: 'fileLink' })
export class FileLinkPipe implements PipeTransform {
  transform(fileId: number | string | null | undefined): string {
    return fileViewerUrl(fileId);
  }
}
